import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STAKEHOLDER_TYPES } from '@/containers/withStakeholderLogic';
import PersonForm from './PersonForm';
import { getMerchantCountryKey, merchantRegion } from '../selectors/merchant';

const StakeholderForm = ({ stakeholder, merchantCountry, region, ...props }) => {
  const { type, data, ...s } = stakeholder;

  let form;
  switch (type) {
    case STAKEHOLDER_TYPES.PERSON:
      form = <PersonForm {...props} stakeholder={{ ...data, ...s }} />;
      break;
    case STAKEHOLDER_TYPES.COMPANY:
    default:
      throw new Error('Not implemented');
  }

  return <>{form}</>;
};

StakeholderForm.propTypes = {
  merchantCountry: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  stakeholder: PropTypes.shape({
    data: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default connect(state => ({
  merchantCountry: getMerchantCountryKey(state),
  region: merchantRegion(state),
}))(StakeholderForm);
